import React, { useState, useEffect, useRef } from "react";
import Alert from 'react-bootstrap/Alert';
import { StoreContext } from "../store";
import "../App.css";
import webstat from "../images/webstat.JPG";
import Login from "./atoms/molecules/Login";


let AdBox = () => {


  let ads = [
  //{Id:2,DateCreated:'2/01/25',Title:"Diamond Wings Supplies",  Detail1:"An independent importer of top of the line Belgian pigeon feed,grits and minerals", Detail2:"loft and breeding supplies and much more!" , Link:"DIAMONDWINGS.pdf",Image:""},
  //{Id:3,DateCreated:'01/26/25',Title:"Tommy's Feeds", Detail1:"",Detail2:'',Detail3:"", Link:"TOMMY'S FEED FLYER 2025.pdf",Image:"tommylogo2.jpg"},
  // {Id:4,DateCreated:'9/15/22',Title:"For Sale!", Detail1:"Wicker Baskets and 4 Holes Show Cages",Detail2:'Contact Jimmy Corso 201-450-4551.',Detail3:"", Link:"",Image:""},
  //{Id:5,DateCreated:'01/18/25',Title:"Siegel Pigeons", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.siegelpigeons.com/product/benzing-live-smarthub/",Image:"Benzing Smarthub 5 - SPECIAL-.jpg"},
 // {Id:6,DateCreated:'01/26/26',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"SKYTALKAD2026.pdf",Image:"METQCM2025.JPG"},
  // {Id:7,DateCreated:'6/04/23',Title:"California Classic", Detail1:"",Detail2:'',Detail3:"", Link:"CaliforniaClassicAd.png",Image:"CaliforniaLateHatchClassic.png"},
  // {Id:8,DateCreated:'10/05/23',Title:"", Detail1:"This is one auction you don't want to miss! Offering my entire collection of Wout Smeulder!",Detail2:'',Detail3:"", Link:"Ad Final 2023.jpg",Image:"Ad Final 2023small.jpg"},
  // {Id:9,DateCreated:'10/24/23',Title:"Chelsea Loft Auction", Detail1:"Chelsea Loft aquired birds from the TOP lofts like Ganus, Eijerkamp, Oscan and Linda Devries.",Detail2:'Birds available in the Auction are bred in individual cages!',Detail3:"", Link:"chelsealoftauction.pdf",Image:""},
  //{Id:10,DateCreated:'10/25/23',Title:"The Tar Heel Classic OLR", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.tarheelclassicrace.com/",Image:"tarheellogo2.png"},
  //{Id:11,DateCreated:'01/26/25',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.facebook.com/YouCanCOUNTONCARLA",Image:"ReMaxDreams_Carla_Checklist.PNG"},
  //{Id:12,DateCreated:'12/15/23',Title:"Luxurious Handcrafted Soaps", Detail1:"",Detail2:'',Detail3:"", Link:"http://www.gotcocos.com",Image:"cjc_gotcoco_ad.png"},
  //{Id:13,DateCreated:'01/10/24',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"ADFROM HEADERSEEMOREINFORMATION.docx.pdf",Image:"2024qcm.JPG"},
  {Id:10,DateCreated:'12/14/26',Title:"Run by a former CJC member!", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.tarheelclassicrace.com/",Image:"tarheellogo2.png", ImageScale:1},
  //{Id:14,DateCreated:'03/02/24',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"SUPER 2024 YOUNG BIRDS.pdf",Image:"superset2024.JPG"},
  {Id:15,DateCreated:'01/18/25',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.charmedcoder.com/",Image:"charmedcoder.png", ImageScale:1.3},
  //{Id:16,DateCreated:'03/02/25',Title:"Mulligan's Place Loft: Reduction Sale!", Detail1:"",Detail2:'',Detail3:"", Link:"mulligan.pdf",Image:"mulligan.png"},
  {Id:17,DateCreated:'09/16/25',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"LyfeConnectFlyer.png",Image:"LyfeConnectLogo.png", ImageScale:1.2},
  {Id:18,DateCreated:'12/08/25',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"2433d585-8311-4544-a81a-75318a858aae_tripleDFull.png",Image:"tripleDFullAdlogo.png", ImageScale:1},
  {Id:19,DateCreated:'01/02/26',Title:"2026 Perth Amboy Racing Pigeon Club Races", Detail1:"",Detail2:'',Detail3:"", Link:"2026PerthAmboyOpenRaces.pdf",Image:"paof.png", ImageScale:1.2},
  {Id:20,DateCreated:'01/02/26',Title:"Pigeon Care - Bricon", Detail1:"",Detail2:'',Detail3:"", Link:"https://pigeon.care/",Image:"pigeon-care.jpeg", ImageScale:1},
  {Id:21,DateCreated:'10/17/26',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"trajanoski.png",Image:"trajanoski.png", ImageScale:1},
];

  const [shuffled, setShuffle] = useState(ads);
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const touchStartX = useRef(null);

  // Auto-rotation state — refs avoid triggering re-renders
  const pausedRef = useRef(false);
  const isAutoScrollingRef = useRef(false);
  const resumeTimerRef = useRef(null);


  useEffect(() => {

    function shuffle(array) {
      let currentIndex = array.length,  randomIndex;
  
      // While there remain elements to shuffle.
      while (currentIndex != 0) {
  
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
  
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }
      return array;
    }
  
    setShuffle(shuffle([...ads]));

  }, []); // empty dependencies array


  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateArrows();
    el.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    return () => {
      el.removeEventListener('scroll', updateArrows);
      window.removeEventListener('resize', updateArrows);
    };
  }, [shuffled]);


  // ── Auto-rotation ────────────────────────────────────────────────────────────
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    // Respect the user's motion preference.
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) return;

    // Card width (190 px base, 210 px on desktop via CSS) + gap (12 px) = one card step.
    // Read the rendered card width dynamically so the step matches the responsive CSS size.
    const firstCard = el.querySelector('.sponsor-card');
    const CARD_STEP = firstCard ? firstCard.offsetWidth + 12 : 202;
    const DELAY     = 4500;

    const scheduleResume = (ms = 2000) => {
      clearTimeout(resumeTimerRef.current);
      resumeTimerRef.current = setTimeout(() => { pausedRef.current = false; }, ms);
    };

    const pause  = () => { clearTimeout(resumeTimerRef.current); pausedRef.current = true; };
    const resume = () => { pausedRef.current = false; };

    // Only pause on scroll events the user initiated, not ones we triggered.
    const onScroll = () => {
      if (!isAutoScrollingRef.current) {
        pause();
        scheduleResume(2000);
      }
    };

    // Resume only when focus leaves the entire wrapper, not when moving between
    // the arrows and the scroll row.
    const onFocusOut = (e) => {
      if (!wrapper.contains(e.relatedTarget)) resume();
    };

    const wrapper = el.parentElement; // .sponsor-scroll-wrapper

    const tick = () => {
      if (pausedRef.current) return;
      if (el.scrollWidth <= el.clientWidth) return; // no overflow — nothing to rotate

      const maxScroll = el.scrollWidth - el.clientWidth;
      isAutoScrollingRef.current = true;

      if (el.scrollLeft >= maxScroll - 1) {
        // Reached the end — return to the beginning.
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: CARD_STEP, behavior: 'smooth' });
      }

      // Clear the flag after the smooth scroll animation finishes (~600 ms).
      setTimeout(() => { isAutoScrollingRef.current = false; }, 700);
    };

    const interval = setInterval(tick, DELAY);

    wrapper.addEventListener('mouseenter', pause);
    wrapper.addEventListener('mouseleave', resume);
    wrapper.addEventListener('focusin',    pause);
    wrapper.addEventListener('focusout',   onFocusOut);
    el.addEventListener('scroll', onScroll);

    // Stop rotating if the user enables reduced-motion while the page is open.
    const mqHandler = () => { if (mq.matches) clearInterval(interval); };
    mq.addEventListener('change', mqHandler);

    return () => {
      clearInterval(interval);
      clearTimeout(resumeTimerRef.current);
      wrapper.removeEventListener('mouseenter', pause);
      wrapper.removeEventListener('mouseleave', resume);
      wrapper.removeEventListener('focusin',    pause);
      wrapper.removeEventListener('focusout',   onFocusOut);
      el.removeEventListener('scroll', onScroll);
      mq.removeEventListener('change', mqHandler);
    };
  }, [shuffled]);
  // ────────────────────────────────────────────────────────────────────────────


  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    // Pause auto-rotation for the duration of the touch gesture.
    clearTimeout(resumeTimerRef.current);
    pausedRef.current = true;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(dx) > 30 && scrollRef.current) {
      scrollRef.current.scrollBy({ left: dx, behavior: 'smooth' });
    }
    touchStartX.current = null;
    // Resume auto-rotation after a short settling period.
    clearTimeout(resumeTimerRef.current);
    resumeTimerRef.current = setTimeout(() => { pausedRef.current = false; }, 2000);
  };


const accountName = "cjccombine";
  const openFile = (fName) => {

    if(fName.includes('www') || fName.includes('http') || fName.includes('https'))
    {
      window.open(
        fName,
        "_blank"
      );      
    }else{
    window.open(
      `http://api.charmedcoder.com/UploadedFiles/${accountName}/posts/` + fName,
      "_blank"
    );
    }
  };


return (

     <div className="adbox-container">
       <div className="adbox-inner">
         <div className="sponsor-promo-header">
           <button className="sponsor-promo-btn" onClick={() => openFile('addinfo.pdf')}>Promote Your Business or Event &#8212; Become a Sponsor</button>
         </div>
         <div className="sponsor-scroll-wrapper">
           <button
             className="sponsor-arrow sponsor-arrow-left"
             style={{ visibility: showLeft ? 'visible' : 'hidden' }}
             onClick={() => {
               if (scrollRef.current) {
                 const c = scrollRef.current.querySelector('.sponsor-card');
                 scrollRef.current.scrollBy({ left: -(c ? c.offsetWidth + 12 : 202), behavior: 'smooth' });
               }
             }}
             aria-label="Scroll left"
             tabIndex={showLeft ? 0 : -1}
           >&#8249;</button>
           <div
             className="sponsor-scroll-row"
             ref={scrollRef}
             onTouchStart={onTouchStart}
             onTouchEnd={onTouchEnd}
           >
             {shuffled.map((ad) => (
               <div
                 key={ad.Id}
                 className="sponsor-card"
                 onClick={() => openFile(ad.Link)}
               >
                 <div className="sponsor-logo-area">
                    {ad.Image.length > 3 ? (
                      <img
                        src={`../../images/${ad.Image}`}
                        alt={ad.Title || ad.Detail1 || 'Sponsor'}
                        style={{ transform: `scale(${ad.ImageScale || 1})` }}
                      />
                    ) : null}
                 </div>
                 {(ad.Title || ad.Detail1) && (
                   <div className="sponsor-caption">
                     {ad.Title ? ad.Title.toUpperCase() : ad.Detail1}
                   </div>
                 )}
               </div>
             ))}
           </div>
           <button
             className="sponsor-arrow sponsor-arrow-right"
             style={{ visibility: showRight ? 'visible' : 'hidden' }}
             onClick={() => {
               if (scrollRef.current) {
                 const c = scrollRef.current.querySelector('.sponsor-card');
                 scrollRef.current.scrollBy({ left: c ? c.offsetWidth + 12 : 202, behavior: 'smooth' });
               }
             }}
             aria-label="Scroll right"
             tabIndex={showRight ? 0 : -1}
           >&#8250;</button>
         </div>
       </div>
     </div>
  );
};
export default AdBox;
